import { render, staticRenderFns } from "./ConnectedGroups.vue?vue&type=template&id=397d925c&scoped=true&"
import script from "./ConnectedGroups.vue?vue&type=script&lang=js&"
export * from "./ConnectedGroups.vue?vue&type=script&lang=js&"
import style0 from "./ConnectedGroups.vue?vue&type=style&index=0&id=397d925c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d925c",
  null
  
)

export default component.exports